module.exports = __webpack_public_path__ + "img/etoile.37847344.png";